import React from 'react';
import {
  Notification,
  NotificationToastContainer,
} from '@wk/components-v3-react16';
import { useNotification } from '../../utils/hooks/useNotification';

const GlobalNotificationContainer: React.FC = () => {
  const { notifications, closeNotification } = useNotification();

  return (
    <NotificationToastContainer>
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          type={notification.type}
          isOpen={true}
          onClose={() => closeNotification(notification.id)}
          autoCloseTimeoutMS={notification.autoCloseTimeoutMS}
        >
          <div slot="notificationHeading">{notification.heading}</div>
          <span slot="notificationContent">{notification.message}</span>
        </Notification>
      ))}
    </NotificationToastContainer>
  );
};

export default GlobalNotificationContainer;
